module.exports = __webpack_public_path__ + "static/img/driblab_color_white.b9d92f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_color_white.png
// module id = MWoR
// module chunks = 94